interface MinusIconProps {
  size?: number;
  color?: string;
}

const MinusIcon = ({ size = 24, color = 'currentColor' }: MinusIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
  >
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

export default MinusIcon;
